<template>
  <div :class="['div-input', className, 'mt-2', 'mx-3']">
    <div class="display-only" v-if="isDisplay"></div>
    <div class="row">
      <div :class="['input-custom', { error: isValidate }, classLabelName]">
        <label>
          {{ textFloat }}
          <span v-if="isRequired" class="text-danger">*</span>
          <span> :</span>
        </label>
      </div>
      <div :class="['input-custom', { error: isValidate }, classInputName]">
        <input
          :class="['custom-input']"
          :type="type"
          :placeholder="placeholder"
          :name="name"
          :required="required"
          :value="value"
          :size="size"
          @input="$emit('input', $event.target.value)"
          @change="onDataChange"
          @keyup="$emit('onKeyup', $event)"
          @keypress="$emit('onKeypress', $event)"
          :disabled="disabled"
          :maxLength="maxLength"
        />
        <div v-if="buttonAction" class="button-action" @click="buttonAction">
          <font-awesome-icon
            v-if="buttonActionIcon.length"
            :icon="buttonActionIcon"
            :class="[buttonActionClass]"
          />
        </div>
        <img :src="img" alt="logo-lang" v-if="img" class="logo-lang" />
        <span v-if="detail" class="text-desc">{{ detail }} </span>
        <span class="text-error d" v-if="v && v.$error && v.urlkey == false">{{ $t("textValidateUrlkey") }}.</span>
        <span class="text-error d" v-if="v && v.$error && v.invoicePrefix == false">{{ $t("charNotMatch") }}.</span>
      </div>

      <div class="mx-2">
        <div v-if="v && v.$error">
          <span class="text-error" v-if="v.required == false"
            >{{ $t("required") }}.
          </span>
          <span class="text-error" v-else-if="v.minLength == false"
            >{{ $t("enterAtLeast") }} {{ v.$params.minLength.min }}
            {{ $t("chars") }}.
          </span>
          <span class="text-error" v-else-if="v.email == false"
            >{{ $t("emailError") }}.</span
          >
          <span class="text-error" v-else-if="v.integer == false"
            >{{ $t("numOnly") }}.
          </span>
          <span class="text-error" v-else-if="v.maxLength == false"
            >{{ $t("noMoreThan") }} {{ v.$params.maxLength.max }}
            {{ $t("chars") }}.
          </span>
          <span class="text-error" v-else-if="v.decimal == false"
            >{{ $t("numOnly") }}.
          </span>
          <span class="text-error" v-else-if="v.numeric == false"
            >{{ $t("numOnly") }}.
          </span>
          <span class="text-error" v-else-if="v.minValue == false"
            >{{ $t("minValueError") }}.
          </span>
          <span class="text-error d" v-if="v.sameAsPassword == false"
            >{{ $t("passNotMatch") }}.
          </span>
        </div>
      </div>
    </div>
  </div>
  <!-- <div :class="['input-custom', { error: isValidate }]">
      <label>
        {{ textFloat }}
        <span v-if="isRequired" class="text-danger">*</span>
      </label>
      <input
        :class="['custom-input']"
        :type="type"
        :placeholder="placeholder"
        :name="name"
        :required="required"
        :value="value"
        :size="size"
        @input="$emit('input', $event.target.value)"
        @change="onDataChange"
        @keyup="$emit('onKeyup', $event)"
        @keypress="$emit('onKeypress', $event)"
        :disabled="disabled"
      />
    </div> -->
</template>

<script>
export default {
  props: {
    textFloat: {
      required: true,
      type: String
    },
    placeholder: {
      required: true,
      type: String
    },
    type: {
      required: true,
      type: String
    },
    required: {
      required: false,
      type: Boolean
    },
    detail: {
      required: false,
      type: String
    },
    size: {
      required: false,
      type: String
    },
    name: {
      required: false,
      type: String
    },
    value: {
      required: false,
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Number
    },
    isDisplay: {
      required: false,
      type: Boolean
    },
    isRequired: {
      required: false,
      type: Boolean
    },
    isValidate: {
      required: false,
      type: Boolean
    },
    v: {
      required: false,
      type: Object
    },
    className: {
      required: false,
      type: String
    },
    img: {
      required: false,
      type: String
    },
    disabled: {
      required: false,
      type: Boolean
    },
    classLabelName: {
      required: false,
      type: String
    },
    maxLength: {
      required: false,
      type: Number
    },
    classInputName: {
      required: false,
      type: String
    },
    buttonAction: {
      required: false,
      type: Function
    },
    buttonActionClass: {
      required: false,
      type: String
    },
    buttonActionIcon: {
      required: false,
      type: Array
      // default: []
    }
  },
  methods: {
    onDataChange(event) {
      this.$emit("onDataChange", event.target.value);
    }
  }
};
</script>

<style scoped>
.div-input {
  position: relative;
  white-space: nowrap;
}
.input-custom {
  padding: 0px;
}
.input-custom > label {
  color: #16274a;
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: bold;
  width: 100%;
}
.input-custom > input {
  color: #333333;
  /* background-color: white; */
  border: 1px solid #bcbcbc;
  border-radius: 0px;
  padding: 5px 10px;
}
.input-custom > input[size="lg"] {
  height: 45px;
}
.input-custom > input:focus {
  /* border: 1px solid #16274a; */
  border: 1px solid #ffb300;
}
.input-custom.error > input {
  border-color: red !important;
}
.input-custom > input:disabled {
  background-color: #f5f5f5;
}
::-webkit-input-placeholder {
  /* Edge */
  color: rgba(22, 39, 74, 0.4);
}
:-ms-input-placeholder {
  /* Internet Explorer */
  color: rgba(22, 39, 74, 0.4);
}
::placeholder {
  color: rgba(22, 39, 74, 0.4);
}
.custom-input {
  display: block;
  border: none;
  width: 100%;
}
.text-desc {
  color: rgba(22, 39, 74, 0.4);
  font-size: 12px;
}
.display-only {
  position: absolute;
  z-index: 5000;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.text-error {
  color: #ff0000;
  font-size: 14px;
}
.d-grid {
  display: grid;
}
.button-action {
  position: absolute;
  right: 10px;
  top: 0.3rem;
  z-index: 6;
}
.button-action:hover {
  cursor: pointer !important;
}
@media (max-width: 767.98px) {
  /* .div-input {
    margin-top: 0;
  } */
  .input-custom > label {
    font-size: 15px;
  }
  .button-action {
    position: absolute;
    right: 10px;
    /* top: 0rem; */
    z-index: 6;
  }
  /* .input-custom > input {
    margin-left: 20px;
  } */
}
@media (min-width: 992px) and (max-width: 1200px) {
  .input-custom > input {
    margin-left: 25px;
  }
}
</style>
